export default {
  AllMedicalFaq: [],
  selectedMedicalFaqForUpdate: {},
  FilteredMedicalFaq: [],
};
